export const kioskTransactionsResource = {
  name: 'Kiosk Transactions',
  fields: {
    createdAt: 'Paid at',
    receiptReference: 'Receipt reference',
    visitStatus: 'Visit status',
    siteName: 'Premises',
    kioskName: 'Kiosk',
    bayNumber: 'Bay',
    method: 'Method',
    status: 'Payment status',
    depositAmount: 'Deposit',
    finalCharge: 'Charged',
    refundAmount: 'Refund',
    refundState: 'Refund state',
    refundDueAt: 'Refund due since',
    refundExpiresAt: 'Can be collected at the kiosk until',
    refundedAt: 'Refunded onto the card at',
    csRefundedAt: 'Refunded by hand at',
    csRefundNotes: 'Customer service note',
    paidWith: 'Paid with',
    providerRef: 'SoePay reference',
    settleState: 'Settlement',
    settleType: 'SoePay call',
    instructionStatus: 'Call status',
    instructionAmount: 'Amount',
    instructionAttempts: 'Times sent',
    sentCall: 'Last call sent',
    failureReason: 'Reason',
    checks: 'Checks with SoePay',
    lastCheck: 'Last check',
    lastCheckedAt: 'Last checked at',
    nextCheckAt: 'Next automatic check',
    doubleRefund: 'Refunded twice',
    lastError: 'Last answer from SoePay',
  },
  filters: {
    receiptReference: 'Receipt reference',
    octopusCardId: 'Octopus number',
    octopusCardIdHelper: 'The number on the card, without the digit in brackets',
    octopusCardIdInvalid: 'Not a valid Octopus number',
    siteId: 'Premises',
    method: 'Method',
    refundState: 'Refund state',
    from: 'From',
    to: 'To',
  },
  methods: { octopus: 'Octopus', card: 'Card', qr: 'QR payment', free: 'Free (test)' },
  detailsMissing: 'Details missing',
  unknownValue: 'Unknown',
  sessionLink: 'Kiosk transaction',
  wallets: { alipay_hk: 'Alipay HK', wechat_pay: 'WeChat Pay' },
  refundStates: {
    none: 'No refund',
    open: 'Open',
    paid: 'Paid',
    expired_no_attempt: 'Expired: no attempt',
    expired_attempt_failed: 'Expired: attempt failed',
    expired_result_unknown: 'Expired: result unknown',
    expired_reader_replaced: 'Expired: reader replaced',
    paid_after_expiry: 'Paid after expiry',
    refunded_by_hand: 'Refunded by hand',
    released: 'Released',
    captured: 'Charged',
    refund_pending: 'Refund pending',
    refunded: 'Refunded',
    unknown: 'SoePay answer unknown',
    failed: 'With customer service',
  },
  settleStates: {
    none: 'No SoePay call',
    pending: 'Sending',
    unknown: 'Answer unknown',
    done: 'Done',
    failed: 'With customer service',
  },
  settleTypes: {
    card_capture: 'Charge the card',
    card_void: 'Release the card hold',
    card_refund: 'Refund to the card',
    qr_refund: 'Refund to the QR payment app',
    qr_cancel: 'Cancel the QR payment',
  },
  instructionStatuses: { pending: 'Waiting', in_progress: 'In progress', completed: 'Completed', failed: 'Failed', cancelled: 'Cancelled', expired: 'Expired' },
  sentCalls: { capture: 'Capture', cancel: 'Cancel', refund: 'Refund' },
  lastChecks: { done: 'Done', not_done: 'Not done', unclear: 'Not clear', conflict: 'Does not match our record' },
  failureReasons: {
    maav_exceeded: 'Card cannot hold the amount',
    card_not_accepted: 'Card not accepted',
    reader_error: 'Reader error',
    unknown_outcome: 'Result unknown',
    provider_refused: 'SoePay refused it',
    provider_unclear: 'SoePay did not confirm it within 24 hours',
    conflict: "SoePay's record does not match ours",
  },
  sections: { visit: 'Visit', amounts: 'Amounts', refund: 'Refund', costBreakdown: 'Cost breakdown', attempts: 'Refund attempts', soepay: 'SoePay', soepayAttempts: 'SoePay call history' },
  lines: {
    energy: '%{kwh} kWh at HK$%{rate}%{window}',
    sessionFee: 'Session fee',
    timeFee: 'Time fee',
    idleFee: 'Idle fee',
    depositCap: 'Capped at the deposit',
    total: 'Total charged',
  },
  attempts: { at: 'Time', change: 'Change', reason: 'Reader reason', reasonSoepay: 'Reason', count: 'Attempts', detail: 'Detail' },
  markByHand: {
    button: 'Mark refunded by hand',
    title: 'Mark refunded by hand',
    body: 'Record that customer service refunded HK$%{amount} for receipt %{reference} outside the kiosk. The kiosk can still pay it onto the card later; if it does, you get an email.',
    note: 'Note',
    noteHelper: 'How and when it was refunded, for example "FPS 2026-09-30, call ref 4471"',
    confirm: 'Mark refunded',
    done: 'Marked refunded by hand',
    failed: 'Could not mark it refunded by hand',
    bodySoepay: 'Record that customer service refunded HK$%{amount} for receipt %{reference} outside SoePay, for example by FPS. SoePay is not asked to refund it after this. If SoePay still completes a refund of this payment, you get an email to check that the customer was refunded only once.',
  },
  markRefusals: {
    paid: 'This refund was already paid.',
    refunded_by_hand: 'This payment is already marked refunded by hand.',
    open_octopus: 'The refund can still be collected at the kiosk.',
    open_soepay: 'SoePay is still refunding this payment.',
    none_octopus: 'Only an expired refund that is still owed can be marked refunded by hand.',
    none_soepay: 'Only a card or QR payment handed to customer service with money still owed can be marked refunded by hand.',
    soepay_in_progress: 'A SoePay call for this payment is still running. Reload in a few minutes.',
    soepay_unchecked: 'SoePay may already have refunded this payment. Press "Check with SoePay again" first.',
  },
  providerActions: {
    check: 'Check with SoePay again',
    retry: 'Try again',
    retryTitle: 'Send this to SoePay again?',
    retryBody: 'SoePay showed at %{checkedAt} that "%{call}" of HK$%{amount} for receipt %{reference} was not done. Try again sends it to SoePay once more.',
    retryConfirm: 'Send again',
    failed: 'The server did not answer. Try again in a minute.',
    checked: {
      done: 'SoePay shows it done. The payment is complete.',
      not_done_retry: 'SoePay shows it was not done. You can press "Try again".',
      not_done: 'SoePay shows it was not done yet. It is sent again automatically.',
      unclear: "SoePay's answer is not clear yet. Check again later.",
      conflict: "SoePay's record does not match ours. Look at the payment in MARS.",
      none: 'SoePay did not answer, or a call is still running. Check again in a minute.',
    },
    retried: {
      completed: 'SoePay completed it.',
      failed: 'SoePay refused it again. The payment stays with customer service.',
      unknown: 'SoePay did not answer. It is checked again automatically within minutes.',
      retry_scheduled: 'SoePay refused it for now. It is sent again automatically.',
      not_claimed: 'Another run is already working on it. Reload in a minute.',
    },
    refusals: {
      no_soepay_instruction: 'This payment has no SoePay call to check.',
      nothing_to_check: 'There is nothing to check: the SoePay call is waiting to run or has already finished.',
      refunded_by_hand: 'This payment is marked refunded by hand, so it is not sent to SoePay again.',
      not_proven_undone: 'Only a call SoePay shows as not done can be tried again. Press "Check with SoePay again" first.',
      state_changed: 'The payment changed meanwhile. Reload and look again.',
    },
  },
  actions: { export: 'Export CSV' },
  messages: {
    exportFailed: 'Export failed',
    noBreakdown: 'No cost breakdown for this visit',
    breakdownUnreconciled: 'The cost breakdown does not add up: %{error}',
    noAttempts: 'No refund instruction for this payment',
  },
  errors: {
    KIOSK_REFUND_NOT_MARKABLE: 'This payment cannot be marked refunded by hand now',
    KIOSK_DOUBLE_REFUND_NOT_OPEN: 'This payment is not listed as refunded twice now',
    KIOSK_PROVIDER_ACTION_REFUSED: 'This payment cannot be checked or retried now',
    KIOSK_TRANSACTION_NOT_FOUND: 'Kiosk transaction not found',
  },
  tabs: { all: 'All payments', needsAction: 'Needs action' },
  needsAction: {
    groups: { owed: 'Refunds owed', payment_problem: 'Payment problems', refunded_twice: 'Refunded twice', waiting: 'Waiting for the customer' },
    hints: {
      owed: 'The customer did not collect the refund at the kiosk. Refund by hand, then mark it.',
      payment_problem: 'A card or QR payment call did not finish. Open it to check with SoePay or try again.',
      refunded_twice: 'The customer got this refund twice. Recover one, then mark it handled.',
      waiting: 'For information: the customer can still tap the card at the kiosk.',
    },
    amountLabels: { owed: 'Owed', payment_problem: 'Refund', refunded_twice: 'To recover', waiting: 'Refund' },
    owedFor: 'Owed for %{duration}',
    problemFor: 'Problem for %{duration}',
    twiceAgo: 'Paid twice %{duration} ago',
    timeLeft: '%{duration} left to collect',
    movesSoon: 'Moves to Refunds owed at the next hourly check',
    empty: 'Nothing here',
    open: 'Open',
    showMore: 'Show more',
    loadFailed: 'Could not load this list',
    duration: { minutes: '%{n} min', hours: '%{n} h', days: '%{d} d %{h} h' },
  },
  doubleRefund: {
    button: 'Mark handled',
    title: 'Mark the double refund handled',
    body: 'Record what was done about receipt %{reference}: the customer received the refund of HK$%{amount} twice. Any open alert for it is marked handled with the same note.',
    note: 'Note',
    noteHelper: 'What was done, for example "Recovered HK$110.30 by FPS on 2026-10-09"',
    confirm: 'Mark handled',
    done: 'Marked handled',
    failed: 'Could not mark it handled',
    notOpen: 'This payment is no longer listed as refunded twice.',
    notHandled: 'Not handled yet',
    handledLine: '%{at} by %{by}: %{note}',
  },
};
export const kioskTransactions = kioskTransactionsResource;
